@if (type === 'kendo') {
  <kendo-loader type="pulsing" class="z-20"></kendo-loader>
} @else {
  <div class="image"></div>
}

<div class="mask"></div>
